const capitalise = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : "");

export function equipmentParts(unit) {
  return {
    type: capitalise((unit?.type || "").trim()) || "Unassigned",
    makeModel: [unit?.make, unit?.model].map(part => (part || "").trim()).filter(Boolean).join(" "),
    serial: (unit?.serial_number || "").trim(),
  };
}

export function equipmentSummary(unit) {
  const { type, makeModel, serial } = equipmentParts(unit);
  return [type, makeModel, serial && `SN ${serial}`].filter(Boolean).join(" · ");
}
